import { type CurrentSdrData } from 'tendril-v2/src/Data/DataSource/contacts-nest/callSession/entities/callSession.entity';

export const CurrentSdrDataFixture: CurrentSdrData = {
  sdrId: '',
  name: '',
  orgId: '',
  orgName: '',
};
